import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'chunk'
})
export class ChunkPipe implements PipeTransform {

  transform(array: any[], size?: number): any {
    size = Math.max(size, 0);
    const length = array == null ? 0 : array.length;
    if (!length || size < 1) {
      return [];
    }
    let index = 0;
    let resIndex = 0;
    const result = new Array(Math.ceil(length / size));

    while (index < length) {
      result[resIndex++] = array.slice(index, (index += size));
    }
    return result;
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/pipes/chunk.pipe.ts